import {
  cta_linkTextAlert,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { css } from 'styled-components'

import { spacing } from './spacing'
import {
  font_family_weight_medium,
  font_md,
  font_sm,
  fontBold,
  fontFormLabel,
  fontH1,
  fontH2,
  fontH3,
  fontLinkText,
  fontRegular,
  fontSupportMedium,
} from './typography'

export default css`
  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .flex-column {
    display: flex;
    flex-direction: column;
  }

  .flex-1 {
    flex: 1;
  }

  .align-start {
    align-items: flex-start;
  }
  .align-end {
    align-items: flex-end;
  }
  .align-center {
    align-items: center;
  }
  .align-baseline {
    align-items: baseline;
  }
  .align-stretch {
    align-items: stretch;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-around {
    justify-content: space-around;
  }

  .w-full {
    width: 100%;
  }
  .h-full {
    height: 100%;
  }

  // Generate .gap-x classes for 'tailwind-like' CSS
  ${Array(21)
    .fill('')
    .map((_, index) => `.gap-${index} { gap: ${spacing(index)}; }`)} // EXAMPLES
  /*
    .gap-1 { gap: ${spacing(1)}; }
    .gap-2 { gap: ${spacing(2)}; }
    // etc
  */
  
  // TYPOGRAPHY CLASSES
  .font-h1 {
    ${fontH1}
  }

  .font-h2 {
    ${fontH2}
  }

  .font-h3 {
    ${fontH3}
  }

  .font-linktext {
    ${fontLinkText}
  }

  .font-regular {
    ${fontRegular}
  }

  .font-bold {
    ${fontBold}
  }

  .font-form-label {
    ${fontFormLabel}
  }

  .font-error-message {
    ${font_sm};
    font-family: ${font_family_weight_medium};
    color: ${cta_linkTextAlert};
  }

  .font-support-medium {
    ${fontSupportMedium}
  }

  .font-weight-medium {
    font-family: ${font_family_weight_medium};
  }

  .font-sm {
    ${font_sm};
  }

  .font-md {
    ${font_md};
  }

  .text-primary {
    color: ${text_colorTextPrimary};
  }

  .text-secondary {
    color: ${text_colorTextSecondary};
  }
`
